import { useQuery } from '@tanstack/react-query';
import type { Dashboard } from '@travel-planner/shared';
import { api } from '../api/client';

export function useDashboard(tripId: string | null) {
  return useQuery<Dashboard>({
    queryKey: ['dashboard', tripId],
    queryFn: () => api.get<Dashboard>(`/trips/${tripId}/dashboard`),
    enabled: Boolean(tripId),
    staleTime: 60 * 1000,
  });
}

/** WMO weather code → emoji + short label. */
export function weatherCodeInfo(code: number | null): { icon: string; label: string } {
  if (code === null) return { icon: '·', label: '' };
  if (code === 0) return { icon: '☀️', label: 'Clear' };
  if (code <= 3) return { icon: '⛅', label: 'Partly cloudy' };
  if (code <= 48) return { icon: '🌫️', label: 'Fog' };
  if (code <= 57) return { icon: '🌦️', label: 'Drizzle' };
  if (code <= 67) return { icon: '🌧️', label: 'Rain' };
  if (code <= 77) return { icon: '🌨️', label: 'Snow' };
  if (code <= 82) return { icon: '🌦️', label: 'Showers' };
  if (code <= 86) return { icon: '🌨️', label: 'Snow showers' };
  return { icon: '⛈️', label: 'Thunderstorm' };
}
